// BillingCancel.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/BillingCancel.css";

export const BillingCancel: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => navigate("/dashboard");
  const handleViewPlans = () => navigate("/billing");

  return (
    <div className="billing-cancel-page">
      <section className="billing-cancel-section">
        <div className="billing-card billing-cancel__card">
          <header className="billing-card__header">
            <p className="billing-cancel__eyebrow">Billing</p>
            <h2 className="billing-card__title">Subscription not completed</h2>
            <p className="billing-card__subtitle">
              You cancelled the subscription process. No charges were made and
              your current access remains unchanged.
            </p>
          </header>

          <div className="billing-card__body">
            <div className="billing-cancel__alert">
              <p className="billing-cancel__alert-title">
                You’re still on the free plan
              </p>
              <p className="billing-cancel__alert-body">
                You can continue using your current access. If you change your
                mind, you can restart the subscription at any time from the
                Billing page.
              </p>
            </div>

            <div className="billing-cancel__features">
              <p className="billing-cancel__features-title">
                What you’re missing out on with Premium:
              </p>
              <ul className="billing-cancel__features-list">
                <li>
                  Advanced action recommendations tailored to your event setup.
                </li>
                <li>
                  Linking events to your issue identification, so recommended
                  actions stay relevant to the real problems you’ve flagged.
                </li>
                <li>
                  Smarter workflows to move from identified issues to concrete,
                  trackable sustainability actions.
                </li>
              </ul>
            </div>
          </div>

          <footer className="billing-card__footer billing-cancel__footer">
            <div className="billing-cancel__actions">
              <button
                type="button"
                className="billing-button billing-button--secondary billing-cancel__button"
                onClick={handleBackToDashboard}
              >
                Back to dashboard
              </button>

              <button
                type="button"
                className="billing-button billing-button--primary billing-cancel__button"
                onClick={handleViewPlans}
              >
                View subscription options
              </button>
            </div>
          </footer>
        </div>
      </section>
    </div>
  );
};

export default BillingCancel;
